export const isoNow = () => new Date().toISOString();
